(function($) {
    $(function() {

        var $html = $('html');
        var $highContrastModeButton = $("#toggle-high-contrast-mode");
        var highContrastCookieName = 'high_contrast_mode';

        function initializeHighContrast() {

            if ( isHighContrastModeEnabled() ) {
                enableHighContrastMode();
            } else {
                disableHighContrastMode();
            }
        }

        function enableHighContrastMode() {

            // change html css class
            $html.removeClass("no-high-contrast-mode").addClass("high-contrast-mode");

            // set cookie
            $.cookie(highContrastCookieName, "true", {path : "/"});

        }

        function disableHighContrastMode() {

            // change html css class
            $html.removeClass("high-contrast-mode").addClass("no-high-contrast-mode");

            // set cookie
            $.cookie(highContrastCookieName, "false", {path : "/"});

        }

        function isHighContrastModeEnabled() {
            return ($.cookie(highContrastCookieName) == "true") ? true : false;
        }

        $highContrastModeButton.click(function() {

            if ($html.hasClass("no-high-contrast-mode")) {

                enableHighContrastMode();

            } else {

                disableHighContrastMode();
            }

        });

        initializeHighContrast();

    });
})(jQuery);
